import { render, staticRenderFns } from "./ShippingAddressesList.vue?vue&type=template&id=033279b2&"
import script from "./ShippingAddressesList.vue?vue&type=script&lang=js&"
export * from "./ShippingAddressesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports